import { render, staticRenderFns } from "./LargeAuthen.vue?vue&type=template&id=53b1aaaa&scoped=true&"
import script from "./LargeAuthen.vue?vue&type=script&lang=js&"
export * from "./LargeAuthen.vue?vue&type=script&lang=js&"
import style0 from "./LargeAuthen.vue?vue&type=style&index=0&id=53b1aaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1aaaa",
  null
  
)

export default component.exports